<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('close')">
        <div class="modal-container modal__info-text" @click.stop>

          <div class="modal-header">
            <slot name="header">
              default header
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="modal-default-button modal-default-button-ok" @click="$emit('close')">
                OK
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {

}
</script>

<style scoped>
  .modal-default-button {
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 72px;
    right: 15px;
  }

  .modal-footer {
    text-align: center;
  }

  .modal-default-button-ok {
    position: unset;
    top: 0;
    right: 0;
    margin: auto;
    width: 100px;
    float: none;
    text-align: center;
  }

  .modal-default-button {
    cursor: pointer;
  }

  .modal-header, .modal-body {
  text-align: center;
}
</style>